<template>
  <v-row style="padding: 5px;">
    <v-col cols="12" lg="9" xl="10">
      <contentManager
        title="ACTS Game Rules"
        :editMode="editMode"
        :contentLoading="contentLoading"
        :pages="pages"
        :pageList="pageList"
        :sections="sections"
        :examples="examples"
        :contentTagging="contentTagging"
        @updateOrder="updateOrder"
        @updatePage="emitUpdatePage"
        @removePage="emitRemovePage"
        @updateSection="emitUpdateSection"
        @removeSection="emitRemoveSection"
        @updateExample="emitUpdateExample" />      
    </v-col>
    <v-col cols="12" lg="3" xl="2" style="position: sticky">
      <v-row>
        <v-col cols="12">
          <v-card dark color="secondary">
            <v-card-text>
            <v-btn
              v-if="admin"
              @click="toggleEdit"
              dark
              color="primary"
              width="100%"
              style="margin-bottom: 20px">
              Toggle Edit Mode
            </v-btn>
            <v-btn @click="toggleTags()" dark color="primary" width="100%" style="margin-bottom: 20px;">Toggle Tags</v-btn>
            <v-btn
              v-if="admin"
              @click="trello()"
              dark
              color="primary"
              width="100%"
              style="margin-bottom: 20px">
                See what's coming on Trello!
            </v-btn>
            <v-btn
              v-if="admin"
              @click="toggleVersion"
              dark
              color="primary"
              width="100%"
              style="margin-bottom: 20px">
                Toggle Version
            </v-btn>
            <redditVue />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    contentManager: () => import('../components/contentEngine/contentManager'),
    redditVue: () => import('../components/redditVue')
  },
  created() {
    this.getTraits();
    this.getContent();
  },
  methods: {
    ...mapActions('newACTSContent', ['getContent', 'updateOrder', 'updatePage', 'removePage', 'updateContent', 'removeContent', 'updateExample']),
    ...mapActions('newACTSTraits', ['getTraits']),
    ...mapActions(['toggleTags', 'toggleEdit', 'toggleVersion']),
    emitUpdatePage(page) {
      this.updatePage(page);
    },
    emitRemovePage(page) {
      this.removePage(page);
    },
    emitUpdateSection(section) {
      this.updateContent(section);
    },
    emitRemoveSection(section) {
      this.removeContent(section);
    },
    emitUpdateExample(section) {
      this.updateExample(section);
    },
    trello(){
      window.location.href = 'https://trello.com/b/IO3wYJPu/broken-immortals';
    }
  },
  computed: {
    ...mapState(['editMode', 'contentTagging', 'admin']),
    ...mapState('newACTSContent', ['contentLoading', 'pages', 'pageList', 'sections', 'examples'])
  }
};
</script>

<style>

</style>